import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artykul/usfansspreadsheet-kompletny-przewodnik",
    element: <ArticlePage />,
  },
  {
    path: "/artykul/usfansspreadsheet-vs-excel",
    element: <ArticlePage />,
  },
  {
    path: "/artykul/usfansspreadsheet-bezpieczenstwo",
    element: <ArticlePage />,
  },
  {
    path: "/artykul/usfansspreadsheet-dla-poczatkujacych",
    element: <ArticlePage />,
  },
  {
    path: "/artykul/usfansspreadsheet-vs-google-sheets",
    element: <ArticlePage />,
  },
  {
    path: "/artykul/usfansspreadsheet-konfiguracja",
    element: <ArticlePage />,
  },
  {
    path: "/artykul/usfansspreadsheet-szablony",
    element: <ArticlePage />,
  },
  {
    path: "/artykul/usfansspreadsheet-alternatywy",
    element: <ArticlePage />,
  },
  {
    path: "/artykul/usfansspreadsheet-automatyzacja",
    element: <ArticlePage />,
  },
  {
    path: "/artykul/usfansspreadsheet-prywatnosc",
    element: <ArticlePage />,
  },
  {
    path: "/artykul/usfansspreadsheet-dla-firm",
    element: <ArticlePage />,
  },
  {
    path: "/artykul/usfansspreadsheet-problemy",
    element: <ArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;